import { FolderOpenDot } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from 'components/brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

const EmployerBankPartnersFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const bankPartnerOptions: ComboboxFilterOption<string>[] = [
    { label: 'Bangor', value: 'Bangor' },
    { label: 'Unit', value: 'Unit' },
  ]

  const filteredOptions = bankPartnerOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Bank Partners', options: filteredOptions || [] }]}
        placeholder='Search bank partners to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={bankPartnerOptions || []}
          noSelectionText='Bank Partners'
          pluralIdentifier='bank partners'
        >
          <FolderOpenDot size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default EmployerBankPartnersFilter
